import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useTransition, config } from 'react-spring'
import { Modal } from '@entrata/portals-common/lib/components'
import { FullscreenLoader } from 'portal-modules/common/components/loaders'
import { connect } from 'react-redux'
import {
  rootStyle,
  portalStyle,
  StyledWrapper,
  StyledModalDiv,
  StyledTitle,
  StyledContent,
  StyledFooterContent,
  StyledRpModalTimesDiv,
  StyledRpModalHeaderWrapper,
  classifiedModalDivStyle,
  oneTapPayPlaidWrapperStyle,
  classifiedWrapperStyle,
  StyledDotSpan,
} from './atoms'

function RpModal({
  children,
  loadingMsg,
  show,
  title,
  wrapperClass,
  outsideContent,
  footerContent,
  onCancel,
  onClose,
  hideXOverflow,
  isWideDialog,
  customMaxWidth,
  innerWrapperClass,
  noPad,
  isCommunity,
  ContentDivHeight,
  isfromRPOneTapPay,
  titleStyle,
  isClassifiedDelete,
  isClassifiedFilter,
  isMediumDialog,
  isForPlaid,
  isTimes,
  isfromPlaidConfirm,
  oneTapPaySlimCard,
  fromFlexModal,
  newPaymentMethodFields,
  isfromRPOneTapPayNewFields,
  isFromSessionTimeout,
   modalOverModal,
}) {
  const toggleRoot = action => {
    const blurReskinElement = document.getElementById('bg-overlay')
    if (!blurReskinElement?.classList?.contains('blur')) {
      document.getElementById('root')?.classList[action](rootStyle)
      document.getElementById('bg-img')?.classList[action]('blur')
    }
  }
  React.useEffect(() => {
    if (isFromSessionTimeout) {
      if (document.querySelectorAll('div[id^="modal"]').length <= 1 ||
        modalOverModal) {
        toggleRoot(show || modalOverModal  ? 'add' : 'remove')
      }
    } else {
      toggleRoot(show ? 'add' : 'remove')

      return function removeRootStyles() {
        toggleRoot('remove')
      }
    }
  }, [show])

  const handleCancel = () => {
    if (typeof onCancel === 'function') onCancel()
    if (typeof onClose === 'function') onClose()
  }

  const transitions = useTransition(show, null, {
    from: { opacity: 0, transform: 'translateY(35px)' },
    enter: { opacity: 1, transform: 'translateY(0px)' },
    leave: { opacity: 0, transform: 'translateY(-75px)' },
    config: { ...config.wobbly, friction: 24 },
  })

  return transitions.map(
    ({ item, key, props }) =>
      item && (
        <Modal
          className={`${portalStyle}${wrapperClass && ' ' + wrapperClass}`}
          onClose={handleCancel}
          key={key}
        >
          {({ containerProps, titleId }) => (
            <Fragment>
              <StyledWrapper
                style={props}
                css={
                  isfromRPOneTapPay
                    ? oneTapPayPlaidWrapperStyle
                    : isClassifiedDelete && classifiedWrapperStyle
                }
                isWideDialog={isWideDialog}
                customMaxWidth={customMaxWidth}
                isMediumDialog={isMediumDialog}
                className={innerWrapperClass && innerWrapperClass}
              >
                <StyledModalDiv
                  css={isClassifiedDelete && classifiedModalDivStyle}
                  newPaymentMethodFields={newPaymentMethodFields}
                  {...containerProps}
                >
                  {isTimes ? (
                    <StyledRpModalHeaderWrapper>
                      {title && (
                        <StyledTitle
                          isTimes={isTimes}
                          id={titleId}
                          css={titleStyle}
                          isCommunity={isCommunity}
                          isForPlaid={isForPlaid}
                        >
                          {title}
                        </StyledTitle>
                      )}
                      <StyledRpModalTimesDiv onClick={handleCancel}>
                        &times;
                      </StyledRpModalTimesDiv>
                    </StyledRpModalHeaderWrapper>
                  ) : (
                    <>
                      {title && (
                        <StyledTitle
                          isTimes={isTimes}
                          id={titleId}
                          css={titleStyle}
                          isCommunity={isCommunity}
                          isForPlaid={isForPlaid}
                          fromFlexModal={fromFlexModal}
                        >
                          {title}
                          {fromFlexModal && <StyledDotSpan>.</StyledDotSpan>}
                        </StyledTitle>
                      )}
                    </>
                  )}

                  <StyledContent
                    style={{
                      height: ContentDivHeight,
                      overflowX: hideXOverflow ? 'hidden' : 'auto',
                    }}
                    isfromRPOneTapPayNewFields={isfromRPOneTapPayNewFields}
                    newPaymentMethodFields={newPaymentMethodFields}
                    oneTapPaySlimCard={oneTapPaySlimCard}
                    className={`rpModalContentStyles ${
                      isClassifiedFilter && 'liStyle'
                    }`}
                    noPad={noPad}
                    isfromPlaidConfirm={isfromPlaidConfirm}
                  >
                    {children}
                  </StyledContent>
                  {footerContent && (
                    <StyledFooterContent
                      isfromRPOneTapPay={isfromRPOneTapPay}
                      oneTapPaySlimCard={oneTapPaySlimCard}
                      isfromRPOneTapPayNewFields={isfromRPOneTapPayNewFields}
                    >
                      {footerContent}
                    </StyledFooterContent>
                  )}
                </StyledModalDiv>
                {outsideContent}
              </StyledWrapper>
              <FullscreenLoader show={!!loadingMsg}>
                {loadingMsg}
              </FullscreenLoader>
            </Fragment>
          )}
        </Modal>
      ),
  )
}

RpModal.propTypes = {
  /** Content for the modal */
  children: PropTypes.any,
  loadingMsg: PropTypes.string,
  /** Hook to the cancel event when needed */
  onCancel: PropTypes.func,
  /** Hook to the close event. Usually provided by ModalControl. */
  onClose: PropTypes.func,
  /** Toggle the visibility of the modal */
  show: PropTypes.bool,
  /** Modal title */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Escape hatch when needing to make minor additions/adjustments to the container div for the modal */
  wrapperClass: PropTypes.string,
  /** Used by ActionModal, contains the elements to be added to the bottom (inside) of modalbox. The content passed to this prop would be placed outside scrollbar. */
  footerContent: PropTypes.any,
  /** Used by ActionModal, contains the elements to be added to the bottom (outside) of modalbox */
  outsideContent: PropTypes.any,
  hideXOverflow: PropTypes.bool,
  noPad: PropTypes.bool,
  innerWrapperClass: PropTypes.string,
  isCommunity: PropTypes.bool,
  ContentDivHeight: PropTypes.string,
  titleStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isClassifiedDelete: PropTypes.bool,
  isForPlaid: PropTypes.bool,
  isTimes: PropTypes.bool,
  newPaymentMethodFields: PropTypes.bool,
}

RpModal.defaultProps = {
  wrapperClass: '',
  innerWrapperClass: '',
  noPad: false,
  isCommunity: false,
  ContentDivHeight: '100%',
  titleStyle: '',
  isClassifiedDelete: false,
  isForPlaid: false,
  onClose: () => {},
  isTimes: false,
  isfromRPOneTapPay: false,
  isfromPlaidConfirm: false,
  oneTapPaySlimCard: false,
  newPaymentMethodFields: false,
  fromFlexModal: false,
}

export default connect(({ loading }) => ({
  loadingMsg: (loading.modal && loading.modal.message) || '',
}))(RpModal)
